import { render } from "./RhButton.vue?vue&type=template&id=46727939&scoped=true&ts=true"
import script from "./RhButton.vue?vue&type=script&lang=ts"
export * from "./RhButton.vue?vue&type=script&lang=ts"

import "./RhButton.vue?vue&type=style&index=0&id=46727939&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46727939"]])

export default __exports__